/**
 * Streamate camera display component.
 *
 * Requests a random camera from the API, displays the video stream.
 *
 * It is designed to be autonomous, without any arguments.  The API is taking
 * care to provide a new camera with every request.
 */

import { useStreamateCamera } from "./hooks";
import classes from "./StreamateCamera.module.scss";
import { className } from "@/common/utils";
import { SoundButton } from "components/buttons/SoundButton";
import { Video } from "@/components/UI/Video";

interface IProps {
  position: number;
}

export const StreamateCamera = ({ position }: IProps) => {
  const { camera, handleClick, isError, handleToggleSound, isSound, videoRef, playHandler } = useStreamateCamera({ position });

  return (
    <div
      className={className({
        Player: true,
        [classes.StreamateCamera]: true,
      })}
    >
      <div className={classes.backdropContainer}>
        { camera && camera.preview && <img className={classes.backdrop} src={camera.preview} alt=""/> }
      </div>

      {isError && (
        <div className={classes.message}>Nothing to see here, please move on.</div>
      )}

      {!isError && !camera && (
        <div className={classes.message}>Loading...</div>
      )}

      { camera && (
        <>
          <div data-videoads="adsVideo" className={classes.playerContainer}>
            <Video
              videoRef={videoRef}
              controls={false}
              autoPlay={true}
              playsInline={true}
              muted={!isSound}
              src={camera.stream}
              disablePictureInPicture={true}
              onPlay={playHandler}
            />
          </div>

          <div className={classes.controls}>
            <SoundButton
              enabled={isSound}
              onClick={handleToggleSound}
            />
          </div>

          <div className={classes.modelInfo}>
            <div
              className={classes.ctaBubble}
              role='button'
              aria-label={`Join ${camera.nickname} live`}
              onClick={handleClick}
            >
              <div className={classes.callToActions}>
                <div className={classes.avatar}>
                  <img className={classes.modelAvatar} src={camera.thumbnail} alt=''/>
                  <span className={classes.liveBadge}>LIVE</span>
                </div>

                <div className={classes.ctaText}>
                  <div className={classes.model}>{camera.nickname}</div>
                  <div className={classes.status}>&nbsp;is Online now!</div>
                </div>
              </div>

              <button className={classes.joinBtn} type='button'>
                Join LIVE
              </button>
            </div>
          </div>

          <div className={classes.overlap} onClick={handleClick}></div>
        </>
      )}
    </div>
  );
};
